import endsWith from 'lodash/endsWith';

import {
  COUNTRIES_BY_DOMAIN,
  DEFAULT_COUNTRY,
  DEFAULT_LOCALE_BY_COUNTRY,
  DOMAINS_BY_COUNTRY,
  SUPPORTED_LOCALES,
} from '@wecasa/common/src/constants/country';
import type { TLD } from '@wecasa/common/src/types/country';
import { setCurrentCountry } from '@wecasa/common/src/utils/country';
import { uppercaseLastTwo } from '@wecasa/common/src/utils/strings';

import type { Locale } from '@wecasa/i18n';

const isValidDomain = (domain: string | undefined): domain is TLD =>
  !!domain && Object.values(DOMAINS_BY_COUNTRY).includes(domain as TLD);

const getCurrentDomain = () =>
  Object.keys(COUNTRIES_BY_DOMAIN).find((domain) => endsWith(window.location.hostname, domain));

const getCountryByDomain = () => {
  const domain = getCurrentDomain();
  return isValidDomain(domain) ? COUNTRIES_BY_DOMAIN[domain] : DEFAULT_COUNTRY;
};

export const getWebAppLocale = () => {
  const localeFromPathname = uppercaseLastTwo(window.location.pathname.substring(1, 6)) as Locale;

  if (SUPPORTED_LOCALES.includes(localeFromPathname)) {
    return localeFromPathname;
  }

  return DEFAULT_LOCALE_BY_COUNTRY[getCountryByDomain()];
};

export const setCountry = () => {
  setCurrentCountry(getCountryByDomain());
};
